import React, { useEffect, useRef, useState } from 'react';
import { Wheel } from 'react-custom-roulette';
import styled from 'styled-components';

const WheelContainer = styled.div`
  width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  position: relative;
`;

const SpinButton = styled.button`
  padding: 0.8rem 2rem;
  margin-top: 1rem;
  cursor: pointer;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.2rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const SoundButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: #666;
  transition: color 0.3s;

  &:hover {
    color: #000;
  }
`;

const WheelComponent = ({ mustSpin, prizeNumber, segments, onSpinClick, onStopSpinning }) => {
    const [isSoundEnabled, setIsSoundEnabled] = useState(false);
    const spinningSound = useRef(new Audio('/sounds/spinning.mp3'));
    const winSound = useRef(new Audio('/sounds/win.mp3'));

    // Điều chỉnh thời gian quay thành 10 giây
    const spinDuration = 10000; // 10 seconds

    const toggleSound = () => {
        setIsSoundEnabled(!isSoundEnabled);
    };

    const handleSpinClick = () => {
        if (isSoundEnabled) {
            try {
                spinningSound.current.currentTime = 0;
                spinningSound.current.play().catch(error => {
                    console.log("Spinning sound play failed:", error);
                });
            } catch (error) {
                console.log("Spinning sound error:", error);
            }
        }
        onSpinClick();
    };

    const handleStopSpinning = () => {
        if (isSoundEnabled) {
            try {
                // Dừng ngay âm thanh spinning
                spinningSound.current.pause();
                spinningSound.current.currentTime = 0;

                // Phát âm thanh chiến thắng
                winSound.current.currentTime = 0;
                winSound.current.play().catch(error => {
                    console.log("Win sound play failed:", error);
                });
            } catch (error) {
                console.log("Win sound error:", error);
            }
        }
        onStopSpinning();
    };

    useEffect(() => {
        // Cấu hình ban đầu cho âm thanh
        spinningSound.current.preload = 'auto';
        winSound.current.preload = 'auto';

        return () => {
            try {
                spinningSound.current.pause();
                winSound.current.pause();
            } catch (error) {
                console.log("Cleanup error:", error);
            }
        };
    }, []);

    useEffect(() => {
        if (!isSoundEnabled) {
            try {
                spinningSound.current.pause();
                winSound.current.pause();
            } catch (error) {
                console.log("Sound disable error:", error);
            }
        }
    }, [isSoundEnabled]);

    return (
        <WheelContainer>
            <SoundButton onClick={toggleSound}>
                {isSoundEnabled ? '🔊' : '🔇'}
            </SoundButton>
            <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={segments}
                onStopSpinning={handleStopSpinning}
                backgroundColors={['#ff8f43', '#70bbe0', '#0b3351', '#f9dd50']}
                textColors={['#ffffff']}
                outerBorderColor="#eeeeee"
                radiusLineColor="#eeeeee"
                radiusLineWidth={1}
                fontSize={20}
                spinDuration={1.0} // Điều chỉnh tốc độ quay của wheel
            />
            <SpinButton onClick={handleSpinClick} disabled={mustSpin}>
                {mustSpin ? 'ĐANG QUAY...' : 'QUAY'}
            </SpinButton>
        </WheelContainer>
    );
};

export default WheelComponent; 